import translate from '@translate';
import React, { FC } from 'react';
import Grid, { GridItem } from 'src/components/Grid';
import TextField from 'src/components/TextField';
import { PermissionType } from 'src/types/permission';
import { FormErrorsType, OnChangeType } from '../../types/global';
import { EditKeysType } from './index';

export interface DetailPropsType {
    onChange: OnChangeType<EditKeysType>;
    editData: PermissionType;
    editErrors: FormErrorsType;
    newPermission: boolean;
    disableEdit: boolean;
}

const Detail: FC<DetailPropsType> = (props) => {
    return (
        <Grid>
            <GridItem cols={12}>
                <TextField
                    value={props.editData.PID}
                    error={props.editErrors.PID}
                    onChange={(value, error) => props.onChange('PID', value, error)}
                    name="PID"
                    label={translate('permissionDetail.pid')}
                    fullWidth
                    required
                    disabled={props.disableEdit}
                />
                <TextField
                    value={props.editData.DESCRIPTION}
                    error={props.editErrors.DESCRIPTION}
                    onChange={(value, error) => props.onChange('DESCRIPTION', value, error)}
                    name="DESCRIPTION"
                    label={translate('permissionDetail.description')}
                    fullWidth
                    disabled={props.disableEdit}
                />
            </GridItem>
        </Grid>
    );
};

export default Detail;
